import React from 'react'

import { Spinner } from '../../../App/Components'

import { SpinnerOverlay } from './style'

interface IProps {
  loadingText?: string
}

export const AbsoluteSpinner = ({ loadingText }: IProps) => (
  <SpinnerOverlay>
    <Spinner />
    <p>{loadingText}</p>
  </SpinnerOverlay>
)
